export function isMode(mode) {
  return envUiMode === mode
}
